// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ed","articleImagesWrap":"fd","articleImage":"gd","singleImage":"hd"};